/*
 * VigorX v2 — pack selector (snippets/vx-packs.liquid).
 * The only writer of the hidden input[name=quantity] on the product page in v2
 * (vx-quantity.js and vx-bundle-qty-sync.js are not loaded: they mirrored the
 * Vitals widget, which v2 hides, and would overwrite the 4-pack with its tier).
 * Every write dispatches input + change so anything listening hears it.
 */
(function () {
  'use strict';

  /* Lithuanian plural: 1, 21, 31… pakuotė · 2–9, 22–29… pakuotės · 10–20, 30… pakuočių */
  function pakiranja(n) {
    var m10 = n % 10, m100 = n % 100;
    if (m10 === 1 && m100 !== 11) return 'pakuotė';
    if (m10 >= 2 && m10 <= 9 && (m100 < 11 || m100 > 19)) return 'pakuotės';
    return 'pakuočių';
  }

  function init(box) {
    if (box.__vx) return;
    box.__vx = true;
    var input = document.getElementById(box.getAttribute('data-input'));
    var min = parseInt(box.getAttribute('data-gift-min'), 10) || 4;
    var note = box.querySelector('[data-vx-giftnote]');
    var text = note && note.querySelector('.vx-giftnote__text');
    var bars = note ? [].slice.call(note.querySelectorAll('.vx-giftnote__meter i')) : [];

    function apply(qty) {
      [].forEach.call(box.querySelectorAll('.vx-pack'), function (row) {
        row.classList.toggle('is-on', parseInt(row.getAttribute('data-qty'), 10) === qty);
      });
      if (input && String(input.value) !== String(qty)) {
        input.value = qty;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (note) {
        var left = Math.max(min - qty, 0);
        bars.forEach(function (b, i) { b.classList.toggle('is-on', i < qty); });
        note.classList.toggle('is-done', left === 0);
        text.textContent = left === 0
          ? text.getAttribute('data-done')
          : 'Dar ' + left + ' ' + pakiranja(left) + ' ir gausite dovaną nemokamai';
      }
      box.setAttribute('data-qty', qty);
      var row = box.querySelector('.vx-pack[data-qty="' + qty + '"]');
      if (row) {
        var set = function (sel, v) { var el = box.querySelector(sel); if (el) el.textContent = v; return el; };
        set('[data-vx-total]', row.getAttribute('data-total'));
        set('[data-vx-full]', row.getAttribute('data-full') || '');
        var sv = set('[data-vx-save]', row.getAttribute('data-save') ? 'Sutaupote ' + row.getAttribute('data-save') : '');
        if (sv) sv.hidden = !row.getAttribute('data-save');
        set('[data-vx-per]', row.getAttribute('data-per'));
        set('[data-vx-qtytxt]', qty + ' ' + pakiranja(qty));
        document.querySelectorAll('[data-vx-sticky-total]').forEach(function (el) { el.textContent = row.getAttribute('data-total'); });
        document.querySelectorAll('[data-vx-sticky-qty]').forEach(function (el) { el.textContent = qty + ' ' + pakiranja(qty) + (qty >= min && note ? ' + dovana' : ''); });
      }
    }

    box.addEventListener('change', function (e) {
      if (e.target && e.target.name && e.target.name.indexOf('vx-pack-') === 0) apply(parseInt(e.target.value, 10));
    });
    var checked = box.querySelector('input[type=radio]:checked');
    apply(checked ? parseInt(checked.value, 10) : 1);
  }

  /* Mobile sticky buy bar: appears once the real buy button has scrolled away; tapping it
     presses the real button (Releasit COD, or the theme ATC as fallback). */
  function stickyBar() {
    if (document.querySelector('.vx-sticky') || !document.querySelector('[data-vx-packs]')) return;
    var bar = document.createElement('div');
    bar.className = 'vx-sticky';
    var img = document.querySelector('.product__media img');
    var title = document.querySelector('.product__title h1');
    bar.innerHTML = '<div class="vx-sticky__in">' +
      (img ? '<img class="vx-sticky__img" alt="" src="' + (img.currentSrc || img.src) + '">' : '') +
      '<div class="vx-sticky__name">' + (title ? title.textContent.trim() : '') + '</div>' +
      '<div class="vx-sticky__info"><b data-vx-sticky-total></b><span data-vx-sticky-qty></span></div>' +
      '<button type="button" class="vx-sticky__add"><svg class="lt-btn-ico" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M3 4h2l2.4 10.2a1.5 1.5 0 0 0 1.5 1.1h8.3a1.5 1.5 0 0 0 1.4-1l1.9-6.3H6.2" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.5" cy="19.5" r="1.4" fill="currentColor"/><circle cx="17" cy="19.5" r="1.4" fill="currentColor"/></svg><span>Į krepšelį</span></button>' +
      '<button type="button" class="vx-sticky__btn"><svg class="lt-btn-ico" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 7.5A2.5 2.5 0 0 1 6.5 5H18v3M4 7.5V17a2 2 0 0 0 2 2h13a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H6.5A2.5 2.5 0 0 1 4 7.5Z" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"/><circle cx="16" cy="13.5" r="1.3" fill="currentColor"/></svg><span>Užsakyti dabar</span></button></div>';
    document.body.appendChild(bar);
    var box = document.querySelector('[data-vx-packs]');
    var row = box.querySelector('.vx-pack.is-on');
    if (row) { bar.querySelector('[data-vx-sticky-total]').textContent = row.getAttribute('data-total'); var q = +box.getAttribute('data-qty') || 1; bar.querySelector('[data-vx-sticky-qty]').textContent = q + ' ' + pakiranja(q); }
    bar.querySelector('.vx-sticky__add').addEventListener('click', function () {
      var a = document.querySelector('.product-form__submit'); if (a) a.click();
    });
    bar.querySelector('.vx-sticky__btn').addEventListener('click', function () {
      var b = document.querySelector('#rsi_buy_now_button, .rsi_buy_now_button') || document.querySelector('.product-form__submit');
      if (b) b.click();
    });
    function target() { return document.querySelector('#rsi_buy_now_button, .rsi_buy_now_button') || document.querySelector('.product-form__buttons'); }
    var t = 0;
    function check() {
      t = 0;
      var el = target(); if (!el) return;
      var r = el.getBoundingClientRect();
      // LT v2: step aside once the footer comes into view, so it is never covered (Kenan 2026-10-13)
      var foot = document.querySelector('.vx-foot');
      var footIn = foot && foot.getBoundingClientRect().top < window.innerHeight;
      bar.classList.toggle('is-on', r.bottom < 0 && !footIn);
    }
    window.addEventListener('scroll', function () { if (!t) t = setTimeout(check, 80); }, { passive: true });
    check();
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-vx-packs]'), init); stickyBar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  window.vxPacks = { qty: function () { var b = document.querySelector('[data-vx-packs]'); return b ? parseInt(b.getAttribute('data-qty'), 10) || 1 : null; } };
})();
